import { SnackbarProvider, useSnackbar, VariantType, WithSnackbarProps } from 'notistack';
import React from 'react';
import { makeStyles } from '@mui/styles';

interface IProps {
  setUseSnackbarRef: (showSnackbar: WithSnackbarProps) => void;
}

const InnerSnackbarUtilsConfigurator: React.FC<IProps> = (props: IProps) => {
  props.setUseSnackbarRef(useSnackbar());
  return null;
};

let useSnackbarRef: WithSnackbarProps;
const setUseSnackbarRef = (useSnackbarRefProp: WithSnackbarProps) => {
  useSnackbarRef = useSnackbarRefProp;
};

export const SnackbarUtilsConfigurator = () => {
  return <InnerSnackbarUtilsConfigurator setUseSnackbarRef={setUseSnackbarRef} />;
};

type SnackbarOptions = {
  action?: (key: string | number) => React.ReactElement;
  persist?: boolean;
  autoHideDuration?: number;
};

export const SnackbarUtil = {
  success(msg: string, options?: SnackbarOptions) {
    this.toast(msg, 'success', options);
  },
  warning(msg: string, options?: SnackbarOptions) {
    this.toast(msg, 'warning', options);
  },
  info(msg: string, options?: SnackbarOptions) {
    this.toast(msg, 'info', options);
  },
  error(msg: string, options?: SnackbarOptions) {
    this.toast(msg, 'error', options);
  },
  toast(msg: string, variant: VariantType = 'default', options?: SnackbarOptions) {
    useSnackbarRef.enqueueSnackbar(msg, { variant, ...options });
  },
  close() {
    useSnackbarRef.closeSnackbar();
  },
};

export const SnackbarComponent = () => {
  const classes = useStyles();
  return (
    <SnackbarProvider
      maxSnack={1}
      anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
      classes={{
        variantInfo: classes.variantInfo,
        variantWarning: classes.variantWarning,
        variantSuccess: classes.variantSuccess,
        variantError: classes.variantError,
      }}
    >
      <SnackbarUtilsConfigurator />
    </SnackbarProvider>
  );
};

export const variantClass = {
  width: 330,
  borderRadius: 20,
  display: 'flex',
  alignItems: 'flex-start',
  padding: 20,
};

const useStyles = makeStyles({
  variantInfo: {
    ...variantClass,
    background:
      'linear-gradient(0deg, rgba(255, 255, 255, 0.01), rgba(255, 255, 255, 0.01)),rgb(91 91 91 / 22%)',
    backdropFilter: 'blur(50px)',
    padding: '12px 30px',
    boxShadow: 'none',
  },
  variantWarning: {
    ...variantClass,
    background:
      'linear-gradient(180deg, rgba(246, 188, 2, 1) 0%, rgba(240, 138, 0, 1) 100%) !important',
  },
  variantSuccess: {
    ...variantClass,
    background:
      'linear-gradient(180deg, rgba(155, 216, 32, 1) 0%, rgba(55, 185, 56, 1) 100%) !important',
  },
  variantError: {
    ...variantClass,
    background:
      'linear-gradient(180deg, rgba(253, 116, 61, 1) 0%, rgba(238, 83, 20, 1) 100%) !important',
  },
});
